import Api from '../http.service';

/**get General Item By Type
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.email
 * @param {String} payload.data.message
 */
export const sendClaim = (payload) =>
  Api.POST({
    url: `claim/send`,
    data: payload.data,
  });
